import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import {uuid} from '@aofl/uuid';
import '../collapse-sdo';
import {sdoNs} from '../../../constants-enumerate';

/**
 * @summary EmsCollapse
 * @extends {mapStatePropertiesMixin(AoflElement)}
 */
@customElement('ems-collapse')
class EmsCollapse extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of EmsCollapse.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
  }
  /**
   * @readonly
   * @type {String}
   */
  static is = 'ems-collapse';
  /**
   * @type {String}
   */
  collapseId = '';
  /**
   * @type Boolean
   */
  @property({type: Boolean, reflect: true})
  open = false;
  /**
   * @type {String}
   */
  @property({type: String})
  group = 'ungrouped';
  /**
   * Adds the collapse element to store
   * @private
   */
  addToState() {
    this.storeInstance.commit({
      namespace: sdoNs.COLLAPSE,
      mutationId: 'add',
      payload: {
        groupId: this.group,
        id: this.collapseId,
        open: this.open
      }
    });
  }
  /**
   * Uses element's id attribute or a uuid if isn't set and adds the element to store.
   */
  connectedCallback() {
    this.collapseId = this.getAttribute('id') || uuid();
    this.addToState();

    super.connectedCallback();
  }
  /**
   * Mapps the state of the collapse from store to this.open
   */
  mapStateProperties() {
    const state = this.storeInstance.getState();
    const currentOpen = this.open;
    this.open = state[sdoNs.COLLAPSE][this.group][this.collapseId];

    if (this.open !== currentOpen) {
      this.dispatchEvent(new CustomEvent('collapse-change'));
    }
  }
  /**
   * Renders the element
   *
   * @return {TemplatePart}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default EmsCollapse;
